import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { RephraseRequest } from '../../../shared/models/rephraseRequest.d';
import { RephraseResponse } from '../../../shared/models/rephraseResponse.d';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RephraseService extends BaseService {
  constructor() {
    const http = inject(HttpClient);

    super(http);
  }

  public rephraseText(request: RephraseRequest): Observable<RephraseResponse> {
    return this.post<RephraseResponse>('v1/Translate/improve', request);
  }
}
